import {
  type DocWorkflowData,
  type DocWorkflowStepQuestionDatum,
  type DocWorkflowUpdatePayload,
} from "~utils";

type WorkflowAttributes = NonNullable<DocWorkflowUpdatePayload["attributes"]>;

export function getAttributes(
  state: DocWorkflowStepQuestionDatum[] | undefined,
  { changed = false }: { changed?: boolean } = {},
): WorkflowAttributes {
  if (!state?.length) {
    return [];
  }
  return state
    .filter((row) => (changed ? row.answerValue !== row.storedValue : true))
    .map((row) => ({
      attribute: row.attribute,
      value: row.answerValue ?? "",
    }))
    .filter((entry) => entry.value !== "");
}

export function calcProgress(taskData: DocWorkflowData): number {
  const { nQuestions, nQuestionsAnswered } = taskData;

  if (nQuestions <= 0) return 0;

  const nChanged = getAttributes(taskData.stepQuestionsData, { changed: true }).length;

  return Math.min(100, Math.round(((nQuestionsAnswered + nChanged) / nQuestions) * 100));
}
